import React, { useEffect, useState, useRef } from "react";
import Table from "../../../../library/custom/table/table";
import { COLORS, PAGE_SIZE_500, USER_ID } from "../../../../constant/constant";
import { useLocation, useNavigate } from "react-router-dom";
import {
  CONDUCT_JHA_REPORT,
  COURSESDETAIL,
  LESSONDETAIL,
  TOOL_BOX_DETAIL,
} from "../../../../constant/routeContant";
import {
  downloadExcel,
  downloadPDF,
  getFormatedDate,
  useInfiniteScroll,
} from "../../../../utils/helper";
import commonImages from "../../../../assets";
import { Grid, Popover } from "@mui/material";
import ReportRowManipulte from "../../../incidents/incidentList/ReportRowManipulte";
import LineChart from "../../../../library/custom/charts/linechart";

const CompletedTraining = (props) => {
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);

  const [sortColumn, setSortColumn] = useState();
  const [sortDirection, setSortDirection] = useState("asc");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const reportType = useRef();
  const location = useLocation();
  const [isAllDataLoaded, setIsAllDataLoaded] = useState(false);

  const tableRef = useInfiniteScroll(() => {
    if (!isAllDataLoaded) {
      fetchData(page + 1);
    }
  }, [page, isAllDataLoaded]);

  const formatDate = (date) => {
    const day = date?.getDate()?.toString()?.padStart(2, "0");
    const month = (date?.getMonth() + 1)?.toString()?.padStart(2, "0");
    const year = date?.getFullYear();
    return `${month}-${day}-${year}`;
  };

  const getDaysDifference = (startDate, endDate) => {
    return Math.floor((endDate - startDate) / (1000 * 60 * 60 * 24));
  };

  const generateDateRange = (startDate, endDate) => {
    const dates = [];
    let currentDate = new Date(startDate);
    while (currentDate <= endDate) {
      dates?.push(new Date(currentDate));
      currentDate?.setDate(currentDate?.getDate() + 1);
    }
    return dates;
  };

  const aggregateData = (data) => {
    const aggregated = {};
    const startDate = new Date(data[0]?.date);
    const endDate = new Date(data[data.length - 1]?.date);
    const daysDifference = getDaysDifference(startDate, endDate);
    const isDaily = daysDifference <= 60;
    const allDates = generateDateRange(startDate, endDate);
    allDates.forEach((date) => {
      const year = date?.getFullYear();
      const month = (date?.getMonth() + 1)?.toString().padStart(2, "0");
      const day = date?.getDate()?.toString()?.padStart(2, "0");
      const key = isDaily ? `${year}-${month}-${day}` : `${year}-${month}`;
      aggregated[key] = {
        year,
        month,
        day: isDaily ? day : undefined,
        fullDate: isDaily ? formatDate(date) : `${month}-${year}`,
        lessonCount: 0,
        courseCount: 0,
        safetyMeetingCount: 0,
        jhaCount: 0,
      };
    });

    data.forEach((entry) => {
      const date = new Date(entry?.date);
      const year = date?.getFullYear();
      const month = (date?.getMonth() + 1)?.toString()?.padStart(2, "0");
      const day = date?.getDate()?.toString()?.padStart(2, "0");
      const key = isDaily ? `${year}-${month}-${day}` : `${year}-${month}`;

      if (aggregated[key]) {
        aggregated[key].lessonCount += entry.lessonCount || 0;
        aggregated[key].courseCount += entry.courseCount || 0;
        aggregated[key].safetyMeetingCount += entry.safetyMeetingCount || 0;
        aggregated[key].jhaCount += entry.jhaCount || 0;
      }
    });

    return Object.values(aggregated);
  };

  const generateLineChartData = (data) => {
    const aggregatedData = aggregateData(data);

    return {
      labels: aggregatedData.map((entry) => entry.fullDate),
      datasets: [
        {
          label: "Lessons",
          data: aggregatedData.map((entry) => entry.lessonCount || 0),
          borderColor: COLORS.BlueDress,
          backgroundColor: COLORS.BlueDress,
          borderWidth: 2,
          fill: false,
        },
        {
          label: "Courses",
          data: aggregatedData.map((entry) => entry.courseCount || 0),
          borderColor: COLORS.NeonPurple,
          backgroundColor: COLORS.NeonPurple,
          borderWidth: 2,
          fill: false,
        },
        {
          label: "Safety Meetings",
          data: aggregatedData.map((entry) => entry.safetyMeetingCount || 0),
          borderColor: COLORS.BrightAqua,
          backgroundColor: COLORS.BrightAqua,
          borderWidth: 2,
          fill: false,
        },
        {
          label: "Hazard Analysis",
          data: aggregatedData.map((entry) => entry.jhaCount || 0),
          borderColor: COLORS.MediumGreen,
          backgroundColor: COLORS.MediumGreen,
          borderWidth: 2,
          fill: false,
        },
      ],
    };
  };

  const linechartoptions = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            return `${tooltipItem.dataset.label}: ${tooltipItem.raw}`;
          },
        },
      },
    },
    scales: {
      x: {
        beginAtZero: true,
      },
      y: {
        beginAtZero: true,
      },
    },
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  useEffect(() => {
    if (props?.getLmsDashboardReportDetails) {
      setData((prevData) => [
        ...prevData,
        ...props?.getLmsDashboardReportDetails?.result,
      ]);
      if (props?.getLmsDashboardReportDetails?.result?.length < PAGE_SIZE_500) {
        setIsAllDataLoaded(true);
      }
    }
  }, [props?.getLmsDashboardReportDetails]);

  const fetchMoreData = async (pageNumber) => {
    // const { apiData, reportDetails } = props.drillDetail;
    const data = {
      startDate: getFormatedDate(props?.apiData?.startDate),
      endDate: getFormatedDate(props?.apiData?.endDate),
      divisionId:
        props?.apiData?.divisionId === "AllDivision"
          ? 0
          : props?.apiData?.divisionId,
      reportDetails: reportType?.current
        ? reportType?.current
        : props?.apiData?.reportDetails,
      page: pageNumber,
      pageSize: PAGE_SIZE_500,
      isSendMail: false,
    };
    try {
      const response = await props.getMoretDetails(data);
      return response.data || [];
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  };

  const fetchData = async (pageNumber) => {
    fetchMoreData(pageNumber);
    setPage(pageNumber);
  };

  const handleOnClickLesson = (id) => {
    props?.dataClear();
    navigate(LESSONDETAIL, {
      state: { lessonId: id, isAdminLesson: false, fromReportAnalytics: true },
    });
  };
  const handleOnCourse = (id) => {
    props?.dataClear();
    navigate(COURSESDETAIL, {
      state: {
        courseId: id,
        userId: USER_ID(),
        isAdminCourse: false,
        fromReportAnalytics: true,
        courseDetailBackPath: location?.pathname,
        apiData: location?.state?.apiData,
        page: props?.page,
      },
    });
  };
  const handleOnSafety = (safetyData, id, toolboxTalkId) => {
    // dispatch(toolboxAction.clearToolBoxTalk());
    props?.dataClear();

    navigate(TOOL_BOX_DETAIL, {
      state: {
        safetyDetail: {},
        toolboxtalkuyserlist: true,
        toolboxTalkVersionId: safetyData?.toolboxTalkVersionId,
        isCurrentActiveContent: false,
        toolboxTalkId: safetyData?.toolboxId,
        instructorUserId:
          safetyData?.assignInstructorsUsersParentId > 0
            ? safetyData?.assignInstructorsUsersParentId
            : safetyData?.id,
        scheduleId: safetyData?.scheduleId,
        fromMyTraining: true,
        fromCompletedTab: true,
        showDownloadBtn: true,
        fromAssignedTab: false,
        fromReportAnalytics: true,
      },
    });
  };
  const handleOnHazard = (id) => {
    props?.dataClear();
    navigate(CONDUCT_JHA_REPORT, {
      state: { id: id, editMode: true },
    });
  };

  const handleSort = (column) => {
    const newDirection =
      sortColumn === column && sortDirection === "asc" ? "desc" : "asc";
    setSortDirection(newDirection);
    setSortColumn(column);
    const sortedData = [...data].sort((a, b) => {
      if (a[column] < b[column]) return newDirection === "asc" ? -1 : 1;
      if (a[column] > b[column]) return newDirection === "asc" ? 1 : -1;
      return 0;
    });
    setData(sortedData);
  };

  useEffect(() => {
    setData([]);
  }, []);

  const columns = [
    {
      id: "dateCompleted",
      label: `Date Completed`,
      sortable: true,
      isSorted: sortColumn === "dateCompleted",
      sortDirection,
    },
    {
      id: "trainingType",
      label: `Training Type`,
      sortable: true,
      isSorted: sortColumn === "trainingType",
      sortDirection,
    },
    {
      id: "name",
      label: "Training Name",
      sortable: true,
      isSorted: sortColumn === "name",
      sortDirection,
    },
    {
      id: "userName",
      label: "Completed By",
      sortable: true,
      isSorted: sortColumn === "userName",
      sortDirection,
    },
    {
      id: "blank1",
      label: "",
    },
  ];

  const rowsLesson = data?.map((lesson, index) => (
    <tr className="row" key={index}>
      <td>{lesson?.dateCompleted}</td>
      <td>{lesson?.trainingType}</td>
      <td>{lesson?.name}</td>
      <td>{lesson?.userName}</td>
      <td>
        <ReportRowManipulte
          rows={lesson}
          view
          viewOnClick={() => handleOnClickLesson(lesson?.id)}
          viewLabel={"View lesson"}
        />
      </td>
    </tr>
  ));

  const rowsCourse = data?.map((course, index) => (
    <tr className="row" key={index}>
      <td>{course?.dateCompleted}</td>
      <td>{course?.trainingType}</td>
      <td>{course?.name}</td>
      <td>{course?.userName}</td>
      <td>
        <ReportRowManipulte
          rows={course}
          view
          viewOnClick={() => handleOnCourse(course?.id)}
          viewLabel={"View Course"}
        />
      </td>
    </tr>
  ));
  const rowsSafety = data?.map((safety, index) => (
    <tr className="row" key={index}>
      <td>{safety?.dateCompleted}</td>
      <td>{safety?.trainingType}</td>
      <td>{safety?.name}</td>
      <td>{safety?.userName}</td>
      <td>
        <ReportRowManipulte
          rows={safety}
          view
          viewOnClick={() =>
            handleOnSafety(safety, safety?.id, safety?.toolboxId)
          }
          viewLabel={"View Safety Report"}
        />
      </td>
    </tr>
  ));
  const rowsHazard = data?.map((hazard, index) => (
    <tr className="row" key={index}>
      <td>{hazard?.dateCompleted}</td>
      <td>{hazard?.trainingType}</td>
      <td>{hazard?.name}</td>
      <td>{hazard?.userName}</td>
      <td>
        <ReportRowManipulte
          rows={hazard}
          view
          viewOnClick={() => handleOnHazard(hazard?.id)}
          viewLabel={"View"}
        />
      </td>
    </tr>
  ));
  const rowsTraining = data?.map((safety, index) => (
    <tr className="row" key={index}>
      <td>{getFormatedDate(safety?.dateCompleted)}</td>
      <td>{safety?.trainingType}</td>
      <td>{safety?.name}</td>
      <td>{safety?.userName}</td>
      <td>
        <ReportRowManipulte
          rows={safety}
          view
          viewOnClick={
            safety.trainingType === "Lesson"
              ? () => handleOnClickLesson(safety?.id)
              : safety.trainingType === "Course"
                ? () => handleOnCourse(safety?.id)
                : () => handleOnSafety(safety, safety?.id, safety?.toolboxId)
          }
          viewLabel={"View Report"}
        />
      </td>
    </tr>
  ));

  const rowsPdfLesson = data?.map((lesson) => {
    return [
      getFormatedDate(lesson?.dateCompleted),
      lesson?.trainingType,
      lesson?.name,
      lesson?.userName,
    ];
  });

  const downloadAllData = () => {
    const data = {
      startDate: getFormatedDate(props?.apiData?.startDate),
      endDate: getFormatedDate(props?.apiData?.endDate),
      divisionId:
        props?.apiData?.divisionId === "AllDivision"
          ? 0
          : props?.apiData?.divisionId,
      reportDetails: reportType?.current
        ? reportType?.current
        : props?.apiData?.reportDetails,
      page: 1,
      pageSize: PAGE_SIZE_500,
      isSendMail: true,
    };
    props.getMoretDetails(data);
  };

  return (
    <>
      <div className="overviewIns">
        <Grid className="commonBoxShodow" container spacing={2} mt={3}>
          <Grid item md={9} xs={12}>
            <div className="Completed-title">Completed Training</div>
            <Grid>
              <LineChart
                labels={
                  generateLineChartData(
                    props?.getLMSDashboardReport?.data
                      ?.completedTrainingComparison || [],
                  ).labels
                }
                datasets={
                  generateLineChartData(
                    props?.getLMSDashboardReport?.data
                      ?.completedTrainingComparison || [],
                  ).datasets
                }
                options={linechartoptions}
                height="auto"
              />
            </Grid>
          </Grid>
          <Grid item md={3} xs={12}>
            <Grid
              onClick={() => {
                window.scrollTo(0, 500);
                props.setselectedCard("Training");
                setData([]);
                setPage(1);
                reportType.current = 1;
                props.getMoretDetails({
                  startDate: getFormatedDate(props?.apiData.startDate),
                  endDate: getFormatedDate(props?.apiData.endDate),
                  divisionId:
                    props?.apiData.divisionId === "AllDivision"
                      ? 0
                      : props?.apiData.divisionId,
                  reportDetails: 1,
                  page: 1,
                  pageSize: PAGE_SIZE_500,
                  isSendMail: false,
                });
              }}
              mb={2}
              className="commonBoxShodow cursor"
            >
              <div className="titletop small">Total Training</div>
              <div className="discription red">
                {props?.getLMSDashboardReport?.data?.totalTrainingCount}
              </div>
            </Grid>
          </Grid>
          <Grid container gap={2} item md={12} xs={12}>
            <Grid
              onClick={() => {
                window.scrollTo(0, 500);
                props.setselectedCard("lesson");
                setData([]);
                setPage(1);
                reportType.current = 2;
                props.getMoretDetails({
                  startDate: getFormatedDate(props?.apiData.startDate),
                  endDate: getFormatedDate(props?.apiData.endDate),
                  divisionId:
                    props?.apiData.divisionId === "AllDivision"
                      ? 0
                      : props?.apiData.divisionId,
                  reportDetails: 2,
                  page: 1,
                  pageSize: PAGE_SIZE_500,
                  isSendMail: false,
                });
              }}
              mb={2}
              item
              md={2.5}
              className="commonBoxShodow cursor"
            >
              <div className="titletop small">Lessons</div>
              <div className="discription total">
                {props?.getLMSDashboardReport?.data?.totalLessonCount}
              </div>
            </Grid>
            <Grid
              onClick={() => {
                window.scrollTo(0, 500);
                props.setselectedCard("course");
                setData([]);
                setPage(1);
                reportType.current = 3;
                props.getMoretDetails({
                  startDate: getFormatedDate(props?.apiData.startDate),
                  endDate: getFormatedDate(props?.apiData.endDate),
                  divisionId:
                    props?.apiData.divisionId === "AllDivision"
                      ? 0
                      : props?.apiData.divisionId,
                  reportDetails: 3,
                  page: 1,
                  pageSize: PAGE_SIZE_500,
                  isSendMail: false,
                });
              }}
              mb={2}
              item
              md={2.5}
              className="commonBoxShodow cursor"
            >
              <div className="titletop small">Courses</div>
              <div className="discription purple">
                {props?.getLMSDashboardReport?.data?.totalCourseCount}
              </div>
            </Grid>
            <Grid
              onClick={() => {
                window.scrollTo(0, 500);
                props.setselectedCard("safety");
                setData([]);
                setPage(1);
                reportType.current = 4;
                props.getMoretDetails({
                  startDate: getFormatedDate(props?.apiData.startDate),
                  endDate: getFormatedDate(props?.apiData.endDate),
                  divisionId:
                    props?.apiData.divisionId === "AllDivision"
                      ? 0
                      : props?.apiData.divisionId,
                  reportDetails: 4,
                  page: 1,
                  pageSize: PAGE_SIZE_500,
                  isSendMail: false,
                });
              }}
              mb={2}
              item
              md={2.5}
              className="commonBoxShodow cursor"
            >
              <div className="titletop small">Safety Meetings</div>
              <div className="discription blue">
                {props?.getLMSDashboardReport?.data?.totalSafetyMeetingCount}
              </div>
            </Grid>
            <Grid
              onClick={() => {
                window.scrollTo(0, 500);
                props.setselectedCard("hazard");
                setData([]);
                setPage(1);
                reportType.current = 5;
                props.getMoretDetails({
                  startDate: getFormatedDate(props?.apiData.startDate),

                  endDate: getFormatedDate(props?.apiData.endDate),
                  divisionId:
                    props?.apiData.divisionId === "AllDivision"
                      ? 0
                      : props?.apiData.divisionId,

                  reportDetails: 5,
                  page: 1,
                  pageSize: PAGE_SIZE_500,
                  isSendMail: false,
                });
              }}
              mb={2}
              item
              md={2.5}
              className="commonBoxShodow cursor"
            >
              <div className="titletop small">Hazard Analysis</div>
              <div className="discription green">
                {props?.getLMSDashboardReport?.data?.totalHazardAnalysisCount}
              </div>
            </Grid>
          </Grid>
        </Grid>
        <Grid mt={2}>
          <div className="topHeaderDrill">
            <div className="topHeaderDrillLeft">
              <div className="title">
                {props?.selectedCard === "course"
                  ? "Courses"
                  : props?.selectedCard === "lesson"
                    ? "Lessons"
                    : props?.selectedCard === "safety"
                      ? "Safety Meetings"
                      : props?.selectedCard === "hazard"
                        ? "Hazard Analysis"
                        : props?.selectedCard === "Training"
                          ? "Total Training"
                          : ""}
              </div>
            </div>
            <div className="topHeaderDrillRight">
              <div
                className="downloadBox"
                aria-describedby={id}
                variant="contained"
                onClick={handleClick}
              >
                <div className="downloadIcon">
                  <img src={commonImages?.downloadWhite} alt="Download" />
                </div>
                <div className="downloadText">Download Data</div>
              </div>

              <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
              >
                <div className="downloadListBox">
                  <div className="downloadList">
                    <div className="downloads">
                      <div
                        className="downloadListIcon"
                        onClick={() =>
                          downloadPDF(
                            rowsPdfLesson,
                            columns?.map((col) => col?.label),
                            "CompletedTraining.pdf",
                          )
                        }
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            d="M5.5 8.5H6.5V7H7C7.28333 7 7.52083 6.90417 7.7125 6.7125C7.90417 6.52083 8 6.28333 8 6V5.5C8 5.21667 7.90417 4.97917 7.7125 4.7875C7.52083 4.59583 7.28333 4.5 7 4.5H5.5V8.5ZM6.5 6V5.5H7V6H6.5ZM8.5 8.5H10C10.2833 8.5 10.5208 8.40417 10.7125 8.2125C10.9042 8.02083 11 7.78333 11 7.5V5.5C11 5.21667 10.9042 4.97917 10.7125 4.7875C10.5208 4.59583 10.2833 4.5 10 4.5H8.5V8.5ZM9.5 7.5V5.5H10V7.5H9.5ZM11.5 8.5H12.5V7H13.5V6H12.5V5.5H13.5V4.5H11.5V8.5ZM4.5 13C4.0875 13 3.73438 12.8531 3.44062 12.5594C3.14687 12.2656 3 11.9125 3 11.5V1.5C3 1.0875 3.14687 0.734376 3.44062 0.440626C3.73438 0.146876 4.0875 0 4.5 0H14.5C14.9125 0 15.2656 0.146876 15.5594 0.440626C15.8531 0.734376 16 1.0875 16 1.5V11.5C16 11.9125 15.8531 12.2656 15.5594 12.5594C15.2656 12.8531 14.9125 13 14.5 13H4.5ZM1.5 16C1.0875 16 0.734375 15.8531 0.440625 15.5594C0.146875 15.2656 0 14.9125 0 14.5V3H1.5V14.5H13V16H1.5Z"
                            fill="none"
                          />
                        </svg>
                        <span>Download PDF</span>
                      </div>
                    </div>
                  </div>
                  <div className="downloadList">
                    <div className="downloads">
                      <div
                        className="downloadListIcon"
                        onClick={() =>
                          downloadExcel(data, "CompletedTraining.xlsx")
                        }
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_6635_4490)">
                            <path
                              d="M9.22 0.0100392L0.26 1.71004C0.10875 1.73879 0 1.87629 0 2.03004V13.97C0 14.1238 0.10875 14.2613 0.26 14.29L9.22 15.99C9.24 15.9938 9.26 16 9.28 16C9.35375 16 9.4225 15.9775 9.48 15.93C9.55375 15.8688 9.6 15.775 9.6 15.68V0.320039C9.6 0.225039 9.55375 0.131289 9.48 0.0700392C9.40625 0.0087892 9.31375 -0.00746081 9.22 0.0100392ZM10.24 1.92004V4.16004H10.88V4.80004H10.24V6.40004H10.88V7.04004H10.24V8.64004H10.88V9.28004H10.24V11.2H10.88V11.84H10.24V14.08H15.04C15.3925 14.08 15.68 13.7925 15.68 13.44V2.56004C15.68 2.20754 15.3925 1.92004 15.04 1.92004H10.24ZM11.52 4.16004H14.08V4.80004H11.52V4.16004ZM2.14 5.02004H3.78L4.64 6.81004C4.7075 6.95129 4.7675 7.12504 4.82 7.32004H4.83C4.86375 7.20379 4.92875 7.02129 5.02 6.79004L5.97 5.02004H7.47L5.68 7.98004L7.52 11H5.93L4.89 9.05004C4.85125 8.97754 4.81125 8.84379 4.77 8.65004H4.76C4.74 8.74129 4.6925 8.88379 4.62 9.07004L3.58 11H1.98L3.89 8.01004L2.14 5.02004ZM11.52 6.40004H14.08V7.04004H11.52V6.40004ZM11.52 8.64004H14.08V9.28004H11.52V8.64004ZM11.52 11.2H14.08V11.84H11.52V11.2Z"
                              fill="none"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_6635_4490">
                              <rect width="16" height="16" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                        <span>Download .xlsx</span>
                      </div>
                    </div>
                  </div>
                  <div className="downloadList">
                    <div className="downloads">
                      <div
                        className="downloadListIcon"
                        onClick={downloadAllData}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            d="M2 13.5V11H3.5V13.5H12.5V11H14V13.5C14 13.9125 13.8531 14.2656 13.5594 14.5594C13.2656 14.8531 12.9125 15 12.5 15H3.5C3.0875 15 2.73438 14.8531 2.44062 14.5594C2.14687 14.2656 2 13.9125 2 13.5ZM8 11.5L4 7.5L5.05 6.4L7.25 8.6V1H8.75V8.6L10.95 6.4L12 7.5L8 11.5Z"
                            fill="none"
                          />
                        </svg>
                        <span>Download All Data (Email)</span>
                      </div>
                    </div>
                  </div>
                </div>
              </Popover>
            </div>
          </div>
        </Grid>

        <div className="customTableWrapper">
          <Table
            columns={columns}
            rows={
              props?.selectedCard === "Training"
                ? rowsTraining
                : props?.selectedCard === "lesson"
                  ? rowsLesson
                  : props?.selectedCard === "course"
                    ? rowsCourse
                    : props?.selectedCard === "safety"
                      ? rowsSafety
                      : props?.selectedCard === "hazard"
                        ? rowsHazard
                        : props?.apiData.reportDetails
            }
            tableRef={tableRef}
            onSort={handleSort}
          />
        </div>
      </div>
    </>
  );
};

export default CompletedTraining;
